import { render, staticRenderFns } from "./TgNotFound.vue?vue&type=template&id=415e968f&"
import script from "./TgNotFound.vue?vue&type=script&lang=js&"
export * from "./TgNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports